import VendasPage from './VendasPage'

function App() {
  return <VendasPage />
}

export default App
